import { Root as root } from './root'
import { Title as title } from './title'
import { Main as main } from './main'
import { Price as price } from './price'
import { Buttons as button } from './button'
import { Installments as installments } from './installments'

export const SummaryDesktop = {
  root,
  title,
  main,
  price,
  button,
  installments
}
